import type { ReactNode } from "react";

export function EmptyState({
  icon,
  title,
  hint,
  action,
}: {
  icon?: ReactNode;
  title: string;
  hint?: string;
  action?: ReactNode;
}) {
  return (
    <div className="m-auto flex flex-col items-center justify-center gap-1.5 px-4 py-5 text-center">
      {icon && <span className="text-neutral-300">{icon}</span>}
      <p className="text-[0.8125rem] font-bold text-neutral-700">{title}</p>
      {hint && <p className="text-xs leading-relaxed text-neutral-500">{hint}</p>}
      {action}
    </div>
  );
}
